import { render } from "./StudentPopup.vue?vue&type=template&id=75bae240&scoped=true"
import script from "./StudentPopup.vue?vue&type=script&lang=js"
export * from "./StudentPopup.vue?vue&type=script&lang=js"

import "./StudentPopup.vue?vue&type=style&index=0&id=75bae240&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75bae240"]])

export default __exports__